import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { CancellationDueDeath } from 'cancellations/view-models/cancellation-due-death';
import { memo } from 'react';
import { useFormikContext } from 'formik';
import ProfessionTitleForm from 'shell/components/shared/profession-title-form';
import { noop } from 'shell/utils/noop';

interface ProfessionAccordionProps {
  expanded: boolean;
  toggle: () => void;
}

const ProfessionAccordionComponent = ({
  expanded,
  toggle,
}: ProfessionAccordionProps): React.ReactElement => {
  const formContext = useFormikContext<CancellationDueDeath>();
  const { professionForm } = formContext.values;
  return (
    <Accordion expanded={expanded} onChange={toggle}>
      <AccordionSummary
        aria-controls="panel-profession-content"
        id="panel-profession-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Professione / Titolo di studio</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ProfessionTitleForm
          onChangeValues={noop}
          onChange={noop}
          values={professionForm}
          disabled
        />
      </AccordionDetails>
    </Accordion>
  );
};

ProfessionAccordionComponent.displayName = 'Accordion person';

const ProfessionAccordion = memo(ProfessionAccordionComponent);

export default ProfessionAccordion;
